'use client'

import { Button } from '@radix-ui/themes'
import { ComponentPropsWithoutRef } from 'react'

type CancelButtonProps = ComponentPropsWithoutRef<typeof Button> & {
    loading?: boolean
}

/**
 * Standardized cancel/close button component
 * Always uses red color with soft variant for consistency across the application
 */
export const CancelButton = ({
    children,
    type = 'button',
    color = 'red',
    variant = 'soft',
    loading = false,
    disabled,
    ...props
}: CancelButtonProps) => {
    return (
        <Button
            color={color}
            variant={variant}
            type={type}
            disabled={disabled || loading}
            {...props}
        >
            {children}
        </Button>
    )
}
